import { useMemo } from "react";

/**
 * Render a field of drifting red + white particles behind a section.
 * Pure CSS animations — no JS tick cost.
 */
export default function Particles({ count = 14, className = "" }) {
  const particles = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const white = i % 5 === 0;
      return {
        key: i,
        left: `${Math.random() * 100}%`,
        top: `${60 + Math.random() * 40}%`,
        dx: `${(Math.random() * 80 - 40).toFixed(0)}px`,
        dy: `${-(120 + Math.random() * 260).toFixed(0)}px`,
        dur: `${(7 + Math.random() * 9).toFixed(1)}s`,
        delay: `${(Math.random() * 10).toFixed(1)}s`,
        white,
      };
    });
  }, [count]);

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden>
      {particles.map((p) => (
        <span
          key={p.key}
          className={`btr-particle ${p.white ? "white" : ""}`}
          style={{
            left: p.left,
            top: p.top,
            "--dx": p.dx,
            "--dy": p.dy,
            "--dur": p.dur,
            "--delay": p.delay,
          }}
        />
      ))}
    </div>
  );
}
